// Book cover images for the application
export const BOOK_COVERS = {
  // Fiction books
  'between-two-worlds': 'https://images.unsplash.com/photo-1544947950-fa07a98d237f?w=300&h=400&fit=crop',
  'the-last-library': 'https://images.unsplash.com/photo-1512820790803-83ca734da794?w=300&h=400&fit=crop',
  'code-red': 'https://images.unsplash.com/photo-1543002588-bfa74002ed7e?w=300&h=400&fit=crop',
  'daughters-of-singapore': 'https://images.unsplash.com/photo-1519682337058-a94d519337bc?w=300&h=400&fit=crop',
  'sound-of-silence': 'https://images.unsplash.com/photo-1495446815901-a7297e633e8d?w=300&h=400&fit=crop',
  'island-voices': 'https://images.unsplash.com/photo-1524578271613-d550eacf6090?w=300&h=400&fit=crop',
  'memory-keeper': 'https://images.unsplash.com/photo-1589998059171-988d887df646?w=300&h=400&fit=crop',
  'across-the-sea': 'https://images.unsplash.com/photo-1476275466078-4007374efbbe?w=300&h=400&fit=crop',
  'rain-collector': 'https://images.unsplash.com/photo-1516979187457-637abb4f9353?w=300&h=400&fit=crop',
  'wishing-moon': 'https://images.unsplash.com/photo-1532012197267-da84d127e765?w=300&h=400&fit=crop',
  'quantum-garden': 'https://images.unsplash.com/photo-1509021436665-8f07dbf5bf1d?w=300&h=400&fit=crop',
  
  // Non-fiction books
  'wonders-of-coding': 'https://images.unsplash.com/photo-1517694712202-14dd9538aa97?w=300&h=400&fit=crop',
  'climate-change': 'https://images.unsplash.com/photo-1569163139599-0f4517e36f51?w=300&h=400&fit=crop',
  'singapore-stories': 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=300&h=400&fit=crop',
  'roots-routes': 'https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?w=300&h=400&fit=crop',
  'psychology-success': 'https://images.unsplash.com/photo-1544716278-ca5e3f4abd8c?w=300&h=400&fit=crop',
  
  // MTL books
  'semangat': 'https://images.unsplash.com/photo-1481627834876-b7833e8f5570?w=300&h=400&fit=crop',
  'nam-kathaigal': 'https://images.unsplash.com/photo-1512820790803-83ca734da794?w=300&h=400&fit=crop',
  'tamil-tales': 'https://images.unsplash.com/photo-1544947950-fa07a98d237f?w=300&h=400&fit=crop',
  'malay-proverbs': 'https://images.unsplash.com/photo-1491841550275-ad7854e35ca6?w=300&h=400&fit=crop',
  
  // Children's books (MK)
  'bennys-adventure': 'https://images.unsplash.com/photo-1629992101753-56d196c8aabb?w=300&h=400&fit=crop',
  'kisah-kancil': 'https://images.unsplash.com/photo-1512820790803-83ca734da794?w=300&h=400&fit=crop',
  'little-tamil-tales': 'https://images.unsplash.com/photo-1544947950-fa07a98d237f?w=300&h=400&fit=crop',
  'xiao-xiong': 'https://images.unsplash.com/photo-1543002588-bfa74002ed7e?w=300&h=400&fit=crop',
  'magic-seed': 'https://images.unsplash.com/photo-1519682337058-a94d519337bc?w=300&h=400&fit=crop',
  'colours-world': 'https://images.unsplash.com/photo-1495446815901-a7297e633e8d?w=300&h=400&fit=crop',
  'dongwu-pengyou': 'https://images.unsplash.com/photo-1524578271613-d550eacf6090?w=300&h=400&fit=crop',
  'mari-bermain': 'https://images.unsplash.com/photo-1589998059171-988d887df646?w=300&h=400&fit=crop',
  
  // Default placeholder
  'default': 'https://images.unsplash.com/photo-1544947950-fa07a98d237f?w=300&h=400&fit=crop'
};

// Entity logos - using provided logo URLs
export const ENTITY_LOGOS = {
  moe: 'https://customer-assets.emergentagent.com/job_edu-book-manager/artifacts/fi8yvtm4_moe%20logo.svg',
  civica: 'https://customer-assets.emergentagent.com/job_edu-book-manager/artifacts/i7199j0g_civica_logo_desktop.svg',
  rgs: 'https://customer-assets.emergentagent.com/job_edu-book-manager/artifacts/5lilqm9e_vecteezy_school-logo-design-template-vector_8040410.jpg',
  opentrolley: 'https://customer-assets.emergentagent.com/job_edu-book-manager/artifacts/wfdnlt94_opentrolley_logo.png',
  mk: 'https://customer-assets.emergentagent.com/job_edu-book-manager/artifacts/49rermi0_MK%20logo.svg',
};

// Get book cover by title (fuzzy match)
export const getBookCover = (title) => {
  if (!title) return BOOK_COVERS.default;
  
  const normalizedTitle = title.toLowerCase().replace(/[^a-z0-9]/g, '');
  
  for (const [key, url] of Object.entries(BOOK_COVERS)) {
    if (normalizedTitle.includes(key.replace(/-/g, ''))) {
      return url;
    }
  }
  
  // Return a deterministic image based on title hash
  const hash = title.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
  const covers = Object.values(BOOK_COVERS).filter(url => url !== BOOK_COVERS.default);
  return covers[hash % covers.length];
};
